import { ErrorState } from "@/shared/components/ui/ErrorState";
import { formatPaymentMoney, paymentStatusLabels, type Payment } from "../types/paymentTypes";

export function PaymentState({ payment }: { payment: Payment }) {
  return <div className="space-y-2">
    <p role="status" className="font-medium">{paymentStatusLabels[payment.status]}</p>
    <p className="text-sm">{formatPaymentMoney(payment.amountMinor, payment.currency)}
      {payment.card && ` - ${payment.card.brand} ending in ${payment.card.last4}`}</p>
    {payment.status === "succeeded" && <p className="text-sm text-muted-foreground">Payment verified with Stripe.</p>}
    {payment.status === "canceled" && <p className="text-sm text-muted-foreground">This payment request is canceled. This is not a refund.</p>}
    {["processing", "preparing", "canceling", "reconciliation_required"].includes(payment.status) &&
      <p className="text-sm text-muted-foreground">The payment is not resolved yet. Refresh its status before trying another payment.</p>}
    {payment.status === "requires_action" &&
      <p className="text-sm text-muted-foreground">The customer needs to verify this payment with their bank. Use the secure customer form on this device or share its link.</p>}
    {payment.failureMessage && <ErrorState message={payment.failureMessage} />}
    {payment.refundedAmountMinor > 0 && <p className="text-sm">
      Refunded: {formatPaymentMoney(payment.refundedAmountMinor, payment.currency)}. A refund does not authorize another charge.
    </p>}
    {payment.disputeStatus && <p className="text-sm">Dispute: {payment.disputeStatus}. Review this payment in Stripe.</p>}
  </div>;
}
